import { INITIAL_STATE, WeatherLocationsState } from './reducer'

export const weatherLocationsStateSelector = (state: { weatherLocations: WeatherLocationsState }) =>
  state.weatherLocations || INITIAL_STATE
